/**
 * Preferowany sprzęt w teczce (część `sprzet`, kontrakt planu „Rynek dla domu”, sekcja 4, 2026-10-24):
 * `{ moduly, falownik, magazyn, preferencje, zrodlo, zapisano }`. Wykonawca widzi ją przy zleceniu.
 *
 * Wejście to wariant zestawu z asystenta (`suggestKits`): pozycje `items` z `category` (`panels`, `inverter`,
 * `battery`), `model_id`, `model_name`, `quantity` i `spec`. Marki w pozycjach nie ma, więc bierzemy pierwsze
 * słowo nazwy modelu, chyba że któraś z preferowanych marek występuje w nazwie (wtedy ona).
 */

const tekst = (v) => (typeof v === 'string' ? v.trim() : '')
const liczba = (v) => (Number.isFinite(Number(v)) && v !== null && v !== '' ? Number(v) : null)

export const markaZNazwy = (nazwa, znane = []) => {
  const n = tekst(nazwa)
  if (!n) return ''
  const male = n.toLowerCase()
  const znana = znane.find((m) => tekst(m) && male.includes(tekst(m).toLowerCase()))
  if (znana) return tekst(znana)
  return n.split(/\s+/)[0].replace(/[^\p{L}\p{N}-]/gu, '')
}

const pozycja = (items, kategoria) => (items || []).find((i) => i && i.category === kategoria) || null

/**
 * Wariant zestawu -> część `sprzet`. `preferencje`: `{ marki_falownikow, marki_magazynow, full_black }`;
 * `zrodlo`: `asystent` albo `projekt3d`; `teraz`: data zapisu (do testów).
 */
export const sprzetZWariantu = (wariant, { preferencje = {}, zrodlo = 'asystent', teraz = new Date() } = {}) => {
  const items = wariant?.items || []
  const marki = [...(preferencje.marki_falownikow || []), ...(preferencje.marki_magazynow || [])]

  const p = pozycja(items, 'panels')
  const f = pozycja(items, 'inverter')
  const m = pozycja(items, 'battery')

  const moduly = p ? {
    model_id: liczba(p.model_id),
    nazwa: tekst(p.model_name),
    marka: markaZNazwy(p.model_name, marki),
    liczba: liczba(p.quantity),
    mocW: liczba(p.spec?.power_w),
  } : null
  const falownik = f ? {
    model_id: liczba(f.model_id),
    nazwa: tekst(f.model_name),
    marka: markaZNazwy(f.model_name, preferencje.marki_falownikow || []),
    mocKw: liczba(f.spec?.power_kw),
    fazy: liczba(f.spec?.phase ?? f.spec?.phases),
    hybrydowy: Boolean(f.spec?.hybrid ?? f.spec?.is_hybrid ?? /hybry/i.test(tekst(f.model_name))),
  } : null
  const magazyn = m ? {
    model_id: liczba(m.model_id),
    nazwa: tekst(m.model_name),
    marka: markaZNazwy(m.model_name, preferencje.marki_magazynow || []),
    kwh: liczba(m.spec?.capacity_kwh) != null && liczba(m.quantity) != null
      ? Math.round(liczba(m.spec.capacity_kwh) * liczba(m.quantity) * 100) / 100
      : liczba(m.spec?.capacity_kwh),
  } : null

  return {
    moduly,
    falownik,
    magazyn,
    preferencje: {
      marki_falownikow: [...(preferencje.marki_falownikow || [])],
      marki_magazynow: [...(preferencje.marki_magazynow || [])],
      full_black: Boolean(preferencje.full_black),
    },
    zrodlo: zrodlo === 'projekt3d' ? 'projekt3d' : 'asystent',
    zapisano: teraz.toISOString(),
  }
}
